import {useEffect, useState} from "react";

// až bude function style tak https://blog.logrocket.com/using-localstorage-react-hooks/

export function getStorageValue(key, defaultValue) {
    // getting stored value
    const saved = localStorage.getItem(key);
    const initial = JSON.parse(saved);
    return initial || defaultValue;
}

export const useLocalStorage = (key, defaultValue) => {
    const [value, setValue] = useState(() => {
        return getStorageValue(key, defaultValue);
    });

    useEffect(() => {
        // storing input name
        localStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);

    return [value, setValue];
};

export function setStorageValue(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}

export function unsetStorageValue(key) {
    localStorage.removeItem(key);
}